<template>
    <v-container>
        <div v-if="display">
            <v-row justify="space-around">
                <v-badge :content="count" :value="count" color="#ff6d44">
                    <v-icon color="#08b6aa" x-large>
                        mdi-cart
                    </v-icon>
                </v-badge>
            </v-row>
        </div>
        <v-snackbar color="#08b6aa" v-model="snackbar" :timeout="timeout">
            <div class="flex-box">
                {{ text }}
            </div>
        </v-snackbar>
    </v-container>
</template>

<script>
export default {
    name: "CartBadge",
    data() {
        return {
            snackbar: false,
            timeout: 2000,
            text: "Item Added!",
        }
    },
    watch: {
        /* Watcher that changes the Snackbar messsage
        based on increment or decrement of the
        counter. */
        count(newValue, oldValue) {
            if (this.displaySnackbar) {
                // Change Snackbar message 
                if (newValue > oldValue) {
                    this.text = "Item Added!"
                } else if (newValue < oldValue) {
                    this.text = "Item Removed!"
                }

                // Indicate change to user 
                this.snackbar = true;

            }
            this.$emit('update:count', newValue)

        }
    },
    props: {
        'count': Number,
        'display': {
            type: Boolean,
            default: true
        },
        'displaySnackbar': {
            type: Boolean,
            default: true
        }
    },
    emits: ['update:count']
}
</script>

<style>
* {
    font-family: 'Montserrat';
}

.flex-box {
    display: flex;
    justify-content: center;
}
</style>